import React, { useRef }from 'react';
import "../assets/scss/components/popup.scss";
import { CloseIcon } from '../assets/icons/Icons';

const Popup = ({ children, ...props }) => {
    const popup = useRef();
    const closePopup = (e) => {
        e.preventDefault();
        //popup.current.classList.remove('visible');
        if (props.onClose) {
            props.onClose();
        }
    }

    return (
        <>
            {props.withOverlay && <div className="popup-overlay" onClick={closePopup}></div>}
            <div ref={popup} className={`popup visible ${props.withClose ? 'has-close-icon' : ''} ${props.size}`}>
                {props.withClose && <div className="popup-close" onClick={closePopup}><CloseIcon/></div>}
                <div className="popup-content">
                    { children }
                </div>
            </div>
        </>
    );
};

export default Popup;
